import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  private url = baseUrl + gatewayFile;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  addTransaction(createdByName: any, site: any, shift: any, details: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'addTransaction',
      item1: createdByName, item2: site, item3: shift, item4: details })
    .pipe(
      catchError(this.handleError('addTransaction', []))
    );
  }

  getAllTransactions() {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getAllTransactions'})
    .pipe(
      catchError(this.handleError('getAllTransactions', []))
    );
  }

  getCountryTransactions(country: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getCountryTransactions', item1: country})
    .pipe(
      catchError(this.handleError('getCountryTransactions', []))
    );
  }

  getBranchTransactions(branchCode: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getBranchTransactions', item1: branchCode})
    .pipe(
      catchError(this.handleError('getBranchTransactions', []))
    );
  }

  getSiteTransactions(siteId: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getSiteTransactions', item1: siteId})
    .pipe(
      catchError(this.handleError('getSiteTransactions', []))
    );
  }

  getNewAllTransactions(fetchedDate) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getNewAllTransactions', item1: fetchedDate})
    .pipe(
      catchError(this.handleError('getNewAllTransactions', []))
    );
  }

  getNewCountryTransactions(country: any, fetchedDate) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getNewCountryTransactions',
      item1: country, item2: fetchedDate})
    .pipe(
      catchError(this.handleError('getNewCountryTransactions', []))
    );
  }

  getNewBranchTransactions(branchCode: any, fetchedDate) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getNewBranchTransactions',
      item1: branchCode, item2: fetchedDate})
    .pipe(
      catchError(this.handleError('getNewBranchTransactions', []))
    );
  }

  getNewSiteTransactions(siteId: any, fetchedDate) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getNewSiteTransactions',
      item1: siteId, item2: fetchedDate})
    .pipe(
      catchError(this.handleError('getNewSiteTransactions', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
